<template>
  <div>
    <HeaderBreadcrumbs
      :items="[{ label: 'Dynamic SO', to: '/dynamic-so' }]"
      title="All Dynamic SO"
    />
    <div class="bg-white my-3">
      <div class="flex justify-between bg-white py-3 px-4">
      <div>
        <div>
          <div class="relative">
            <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" width="20" height="20"
              fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 2a8 8 0 016.32 12.906l4.387 4.387a1 1 0 01-1.415 1.415l-4.387-4.387A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z" />
            </svg>
              <input placeholder="Search by Ticket No. and SO No.."
          class="p-2.5 pl-5 w-96 text-sm text not-italic border rounded-lg" v-model="searchForm"
          @input="onInput" v-on:keyup.enter="fetchData" />
            <button v-if="searchForm"
              class="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
              @click="reset" title="Clear search">
              ✕
            </button>
          </div>
        </div>
      </div>
      <t-dropdown>
        <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }" class="flex">
          <button
            class="flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
            @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler" @keydown="keydownHandler">
            <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
            </svg>
            Filter
            <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <polygon
                points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
            </svg>
            <div v-if="dataBadge"
              class="rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center">
              {{ dataBadge }}
            </div>
          </button>
        </div>
        <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg" slot-scope="{ hide, blurHandler }">
          <div
            class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
            role="menuitem">
            <div class="flex justify-between mb-3 mt-2">
              <div>Filter</div>
              <div @click="hide">
                <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M6 18 17.94 6M18 18 6.06 6" />
                </svg>
              </div>
            </div>
            <div class="block w-full mb-2">Order Date</div>
            <div class="grid gap-4 grid-cols-2">
              <div>
                <DatetimeCustom :timeDate="false" :label="'Start Date'" v-model="start_date" @blur="blurHandler">
                </DatetimeCustom>
              </div>
              <div>
                <DatetimeCustom :timeDate="false" :label="'End Date'" v-model="end_date" @blur="blurHandler">
                </DatetimeCustom>
              </div>
              <div>
                <label class="text-gray-600 font-semibold mb-3 mt-2">Offer Type</label>
                <FilterComponent v-model="offerType" :options="offerTypeOptions" :defaultText="'Select Type Option'" />
              </div>
              <div>
                <label class="text-gray-600 font-semibold mb-3 mt-2">Status</label>
                <FilterComponent v-model="statusSo" :options="statusOptions" :defaultText="'Select Status'" />
              </div>
            </div>

            <div class="flex justify-between m">


            </div>
            <div class="mt-3">
              <button class="border bg-blue-500 px-4 py-2 text-white rounded-lg" @click="fetchData()"
                @blur="blurHandler">
                Filter
              </button>
              <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="reset()"
                @blur="blurHandler">Reset</button>
            </div>

          </div>

        </div>
      </t-dropdown>
    </div>
    <div>
      <div class="text-left mt-0 bg-white">
        <t-table class=" shadow-none" :data="items">

          <template v-if="isLoading" v-slot:tbody="props">
            <tbody :class="props.tbodyClass">
              <tr :class="[props.trClass, 'text-center']">
                <td :class="props.tdClass" colspan="15">
                  <div role="status" class="flex justify-center items-center h-72">
                    <svg aria-hidden="true"
                      class="w-8 h-8 text-gray-200 text-center animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                    </svg>
                    <span class="sr-only text-center items-center">Loading...</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
          <template v-else-if="!items.length" v-slot:tbody="props">
            <tbody :class="props.tbodyClass">
              <tr :class="[props.trClass, 'text-center']">
                <td :class="props.tdClass" colspan="15">
                  <div class="flex-col items-center justify-center flex-nowrap flex h-96">
                    <svg width="35" height="35" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z"
                        fill="#4B5563" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z"
                        fill="#4B5563" />
                      <path
                        d="M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z"
                        fill="#4B5563" />
                    </svg>
                    <h4 class="text-base text-gray-600 mb-0">No results found</h4>
                    <p class="text-sm text-gray-500">Change your keyword or filter</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
          <template v-slot:thead="props">
            <thead class="sticky-header">
              <tr>
                <th :class="props.thClass">No</th>
                <th :class="props.thClass">Ticket No.</th>
                <th :class="props.thClass">SO No.</th>
                <th :class="props.thClass">SO Period</th>
                <th :class="props.thClass">Offer Type</th>
                <th :class="props.thClass">Status</th>
                <th :class="props.thClass">Message</th>
                <th :class="props.thClass">
              <div class="flex items-center cursor-pointer" @click="sortBy('created')">
                Created Date
                <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
              </div>
            </th>
            <th :class="props.thClass">
              <div class="flex items-center cursor-pointer" @click="sortBy('modified')">
                Last Modified
                <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
              </div>
            </th>
                <th :class="props.thClass"></th>
              </tr>
            </thead>
          </template>
          <template v-slot:row="props">
            <tr class="text-gray-500">
              <td :class="props.tdClass" class="text-center">
                {{ (currentPage - 1) * perPage + props.rowIndex + 1 }}

              </td>
              <td :class="props.tdClass" class="cursor-pointer text-left">

                {{ props.row?.ticket_number ? props.row?.ticket_number : '-' }}
              </td>
              <td :clas="props.tdClass">
                {{ props.row?.so_number ? props.row?.so_number : '-' }}
              </td>
              <td :clas="props.tdClass">
                {{ props.row?.so_period ? formatDate(props.row?.so_period) : '-' }}
              </td>
              <td :clas="props.tdClass">
                <div v-if="props.row?.offer_type == 1">
                  <span class="text-blue-600 p-1 rounded-lg text-sm font-normal bg-blue-100 text-center">Single</span>
                </div>
                <div v-if="props.row?.offer_type == 2">
                  <span class="text-gray-600 p-1 rounded-lg text-sm font-normal bg-gray-100 text-center">Subscription</span>
                </div>
                <div v-if="props.row?.offer_type == 3">
                 <span class="text-yellow-600 p-1 rounded-lg text-sm font-normal bg-yellow-100 text-center">Bundle</span>
                </div>
                <div v-if="props.row?.offer_type == 4">
                  <span class="text-purple-600 p-1 rounded-lg text-sm font-normal bg-purple-100 text-center">Buffet</span>
                </div>
              </td>
              <td :class="props.tdClass" class="capitalize">
                <span v-if="props.row?.status_so === 200"
                  class="text-green-600 p-1 rounded-lg text-sm font-normal bg-green-100 text-center ">
                  succeed
                </span>
                <span v-else
                  class="text-red-600 p-1 rounded-lg text-sm font-normal bg-red-100 text-center">failed</span>
              </td>
              <td :clas="props.tdClass">
                <div v-if="props.row.attempt === 0" style="width: 250px">
                  Waiting for currency
                </div>
                <div v-else style="width: 360px">
                  {{ props.row?.status_message ? props.row?.status_message : '-' }}
                </div>
              </td>
              <td :class="props.tdClass" class="cursor-pointer text-gray-500 text-left">
                <span>{{ formatDateTime(props.row.created).date }}</span>
                <br>
                <span class="italic text-xs">{{ formatDateTime(props.row.created).time }}</span>
              </td>
              <td :class="props.tdClass" class="cursor-pointer text-gray-500 text-left">
                <span>{{ formatDateTime(props.row.modified).date }}</span>
                <br>
                <span class="italic text-xs">{{ formatDateTime(props.row.modified).time }}</span>
              </td>
              <td :class="props.tdClass" class="cursor-pointer text-gray-500 text-left">
                <button v-if="props.row?.status_so !== 200 && props.row?.attempt !== 0" split
                  split-variant="outline-primary" variant="primary" text="actions" @click="resendSO(props.row)"
                  class="m-2 bg-blue-600 text-white rounded-lg px-2 py-1.5 text-xs font-semibold">
                  Resend
                </button>
              </td>
            </tr>
          </template>
        </t-table>
        <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 items-center my-2 mx-3">
          <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
        </div>
        <div class="mb-0">
          <t-pagination
          :total-items="Number(totalRows)"
          :per-page="perPage"
          v-model="currentPage"
          class="rounded-lg"
          />
        </div>
      </div>
      </div>
    </div>
    </div>

  </div>

</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import constant from '../../store/constant';
import DatetimeCustom from '../../components/form/Datetime.vue'
import FilterComponent from '../../components/form/StatusFilterComponent.vue';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import { EventBus } from '../../event-bus';
const statusSo = [
  {
    text: 'All Status',
    value: '',
  },
  {
    value: 200,
    text: 'Succeed',
  },
  {
    value: 400,
    text: 'Failed',
  },
];

export default {
  name: 'RegisterItemAx',
  components: {
    DatetimeCustom,
    FilterComponent,
    HeaderBreadcrumbs
  },
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      fields: [
        { key: 'No', label: 'No' },
        { key: 'ticket_number', label: 'Ticket Number' },
        { key: 'so_number', label: 'SO Number' },
        { key: 'so_period', label: 'SO Period' },
        { key: 'offer_type', label: 'Offer Type' },
        { key: 'status_so', label: 'Status' },
        { key: 'status_message', label: 'Message' },
        { key: 'created', label: 'created' },
        { key: 'modified', label: 'modified' },
        { key: 'action', label: '' },
      ],
      typing: '',
      searchForm: '',
      statusSo: '',
      statusOptions: [...statusSo],
      offerType: '',
      offerTypeOptions: [
        { value: '', text: 'All Offer' },
        { value: constant.OFFER_TYPE.SINGLE, text: 'Single' },
        { value: constant.OFFER_TYPE.BUNDLE, text: 'Bundle' },
        { value: constant.OFFER_TYPE.SUBSCRIPTIONS, text: 'Subscriptions' },
        { value: constant.OFFER_TYPE.BUFFET, text: 'Buffet' },
      ],
      publisher: [],
      publisherSearchOptions: [],
      isPublisherSearch: false,
      dataBadge: null,
      sortByFilter:null,
      start_date: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
      end_date: moment()
          .endOf('month')
          .format('YYYY-MM-DD'),
      range: {
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD'),
      },
      masks: {
        input: 'YYYY-MM-DD',
      },
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.dynamicSO.isLoading,
      isError: (state) => state.dynamicSO.isError,
      totalRows: (state) => state.dynamicSO.totalRows,
      items: (state) => state.dynamicSO.items,
      errorMessage: (state) => state.dynamicSO.ErrorMessage,
    }),
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Dynamic Item SO | Content Management System Ebooks Gramedia.com';
      },
    },
    errorMessage: function () {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
        message: this.errorMessage,
        type: 'error',
      });
    },

  },
  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions('dynamicSO', ['fetchAllDynamicSO','postResendSO']),

    fetchData() {
      const payload = {
        page: this.currentPage,
        limit: this.perPage,
      };

      if (this.searchForm) payload.q = this.searchForm;
      if (this.statusSo) payload.status_so = this.statusSo;
      if (this.offerType) payload.offer_type = this.offerType;
      if(this.sortByFilter) payload.sort_order = this.sortByFilter.sort_order
      if(this.sortByFilter) payload.sort_by = this.sortByFilter.sort_by

      if (this.range.start && this.range.end) {
        payload.start_period = moment(this.start_date).format('YYYY-MM-DD');
        payload.end_period = moment(this.end_date).format('YYYY-MM-DD');
      }

      this.fetchAllDynamicSO(payload);
      this.filterBadge()
    },

    formatDateString(date) {
      return new Date(date).toString();
    },
    reset() {
      this.searchForm = null || ''
      this.statusSo = null
      this.offerType = null
      this.start_date = moment().startOf('month').format('YYYY-MM-DD'),
      this.end_date = moment().endOf('month').format('YYYY-MM-DD'),
      this.range = {
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD'),
      },
      this.fetchData();
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    formatDateTime(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss'),
      };
    },
    formatDateCreateModified(date) {
      return moment(date).format('DD MMM YYYY HH:mm:ss');
    },
    onInput() {
      this.typing = 'You are typing';
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.typing = null;
        this.currentPage = 1
        this.fetchData();
      }, 600);
    },
    filterBadge() {
      let badgeCount = 0;

      if (this.statusSo) badgeCount += 1;
      if (this.offerType) badgeCount += 1;
      if (this.start_date && this.end_date &&
        !(moment(this.start_date).isSame(moment(), 'month') && moment(this.end_date).isSame(moment(), 'month'))) {
        badgeCount += 1;
      }

      this.dataBadge = badgeCount > 0 ? badgeCount : null;
    },
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return '0';
    },
    onItemStatusChange() {
      this.fetchData();
    },
    setOfferType() {
      this.fetchData();
    },
    sortBy(creteria) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      const queryParam = {
        sort_by: creteria,
        sort_order: this.sortOrder
      }
      this.sortByFilter = queryParam
      this.fetchData();
    },
    resendSO(item) {
      this.postResendSO(item).then((res) => {
        if (res.status === 200) {
          EventBus.$emit('show-toast', {
          message: ' Successfully sent data to 365',
          type: 'success',
        });
        }
      })
        .catch((error) => {
          EventBus.$emit('show-toast', {
          message: error.message,
          type: 'error',
        });
        });

    },
  },
};
</script>
<style scoped>

.badge-purple {
  background-color: #ff06dc;
}

.badge-success {
  background-color: #29932b;
}

.w-custom {
  width: 550px;
}
</style>
